<template>
    <p class="europa-fallback-translation__information">
        <VJoyIcon name="translate" />
        {{ $t(`search.header.host.configured.countries.translation.${state}`) }}
        <LinkButton
            class="europa-fallback-translation__button"
            variant="ghost"
            size="small"
            data-testid="update-translation-preference-btn"
            @click="toggleTranslationPreference"
        >
            {{ $t(`search.header.host.configured.countries.translation.${state}.button`) }}
        </LinkButton>
    </p>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import LinkButton from '~/components/common/LinkButton.vue';
    import {useSearchFeaturesStore} from '../stores/search-features.store';

    const searchFeaturesStore = useSearchFeaturesStore();
    const {translationPreference} = storeToRefs(searchFeaturesStore);

    const state = computed(() => {
        switch (translationPreference.value) {
            case 'MANUAL':
                return 'original';
            case 'AUTO':
            default:
                return 'translated';
        }
    });

    function toggleTranslationPreference() {
        if (translationPreference.value === 'MANUAL') {
            searchFeaturesStore.setTranslationPreference('AUTO');
        } else if (translationPreference.value === 'AUTO') {
            searchFeaturesStore.setTranslationPreference('MANUAL');
        }
    }
</script>

<style scoped lang="scss">
    .europa-fallback-translation {
        &__information {
            margin-top: var(--joy-core-spacing-1);
        }
    }
</style>
